import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentTabIndex, setTabIndex } from "../../model"
import { TransactionsTab } from "../transactions-tab"
import { UserInfoTab } from "../user-info-tab"

export const TabControl = () => {
    const dispatch = useAppDispatch()
    const tabIndex = useAppSelector(selectCurrentTabIndex)

    const handleClick = (index: number) => {
        dispatch(setTabIndex(index))
    }

    return (
        <div className="flexbox">
            <div className="grid grid-cols-12 gap-[1px] w-full auto-rows-fr">
                <div className="col-span-6">
                    <button
                        className={`font-mediumttf text-start uppercase hover:cursor-pointer text-lg xxl:text-[20px] screen:text-2xl py-6 px-5 rounded-l-2xl w-full transition bg-color-dark ${tabIndex === 0 ? 'text-color-acid' : 'text-white hover:text-color-acid'} `}
                        onClick={() => handleClick(0)}
                    >
                        основная информация
                    </button>
                </div>
                <div className="col-span-6">
                    <button
                        className={`font-mediumttf h-full text-start uppercase hover:cursor-pointer text-lg xxl:text-[20px] screen:text-2xl py-6 px-5 rounded-r-2xl w-full transition bg-color-dark ${tabIndex === 1 ? 'text-color-acid' : 'text-white hover:text-color-acid'}`}
                        onClick={() => handleClick(1)}
                    >
                        транзакции
                    </button>
                </div>
            </div>
            {(tabIndex === 0) &&
                <UserInfoTab />
            }
            {(tabIndex === 1) &&
                <TransactionsTab />
            }
        </div>
    )
}